export const commonHttpErrorStatuses = {
	errors: [
		500,
		400,
		403,
		405,
		422,
	],
};
